import { NameBuilderConfiguration, ReprocessingTaskOptionsOverride } from '../../models';
import { IBindableWidgetConfiguration } from '../';
import { IEnableApproval } from '../models/IEnableApproval';

export class ManualInputsWidgetConfiguration implements IBindableWidgetConfiguration, IEnableApproval {
    dateFormat?: string;
    decimals: number;
    enableApproval: boolean;
    group: string;
    identifierQueries: string[];
    includeChildren: boolean;
    isBound?: boolean;
    isVertical?: boolean;
    launchTask: boolean;
    maxColumns: number;
    nameConfiguration: NameBuilderConfiguration;
    referenceGroup?: string;
    showLogbook: boolean;
    showMissingWarnings?: boolean;
    taskOptionsOverride?: ReprocessingTaskOptionsOverride;
    valueFieldWidth?: number;

    constructor() {
        this.decimals = 2;
        this.identifierQueries = [];
        this.includeChildren = false;
        this.isVertical = false;
        this.launchTask = true;
        this.nameConfiguration = new NameBuilderConfiguration();
        this.nameConfiguration.hasGroupName = false;
        this.nameConfiguration.hasName = true;
        this.nameConfiguration.hasShortComment = true;
        this.nameConfiguration.hasUnit = true;
        this.nameConfiguration.hasValueType = false;
        this.showMissingWarnings = true;
        this.showLogbook = false;
        this.taskOptionsOverride = { includeDependent: true };
        this.valueFieldWidth = 18;
    }
}